import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/** Seção da aba Dicionário que um indicador abre. */
export type DictionarySection = 'review' | 'pending' | 'entries' | 'versions';

/**
 * Indicadores do topo da aba Dicionário (task 3452): "A revisar N" (âmbar quando há o que revisar), "Pendentes N" e
 * "Versão em uso vN". Cada um é clicável e abre a seção correspondente. Só apresentação.
 */
@Component({
  selector: 'app-dictionary-summary-bar',
  standalone: true,
  templateUrl: './dictionary-summary-bar.component.html',
  styleUrl: './dictionary-summary-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DictionarySummaryBarComponent {
  /** Nulo enquanto não carregou. */
  readonly toReview = input<number | null>(null);
  readonly pending = input<number | null>(null);
  readonly activeVersionNumber = input<number | null>(null);
  readonly section = input<DictionarySection>('review');

  readonly sectionRequested = output<DictionarySection>();
}
